import { Expose } from 'class-transformer'

export class BookBadge {
  @Expose() badgeImageUrl: string

  @Expose() badgeCategoryId: number
}
